<template>
  <v-form
    validate-on="submit"
    class="custom-form"
    @submit.prevent="onSubmit"
  >
    <v-text-field
      v-model="newPassword"
      label="New Password"
      :type="showPassword ? 'text' : 'password'"
      :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
      :rules="[r.required]"
      autocomplete="new-password"
      class="custom-input mb-3"
      variant="outlined"
      @click:append-inner="showPassword = !showPassword"
      @keyup.enter="onSubmit"
    />

    <v-btn
      :loading="loading"
      type="submit"
      block
      class="custom-button"
    >
      Reset Password
    </v-btn>

    <v-btn
      variant="text"
      class="mt-3"
      @click="$emit('back')"
    >
      Back to login
    </v-btn>
  </v-form>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  const { loading } = defineProps<{ loading?: boolean }>();

  const emit = defineEmits<{
    (e: 'submit', payload: { newPassword: string }): void;
    (e: 'back'): void;
  }>();

  const newPassword = ref('');
  const showPassword = ref(false);
  const r = { required: (v: string) => !!v || 'Password is required' };

  function onSubmit() {
    if (!newPassword.value) return;
    emit('submit', { newPassword: newPassword.value });
  }
</script>

<style scoped lang="sass">
  .custom-form
    width: 100%
    height: 100%
    display: flex
    flex-direction: column

  .custom-input
    width: 100%
    margin-bottom: 24px
    font-size: 16px
    :deep(.v-field)
      border-radius: 10px
      --v-field-border-color: #ccc
      width: 100%

  .custom-button
    border: 2px solid #1976d2
    background-color: transparent
    color: #1976d2
    font-weight: 400
    font-size: 16px
    height: 50px
    border-radius: 10px
    margin-top: 32px
    text-transform: none
    transition: all 0.2s ease
    &:hover
      background-color: rgba(25, 118, 210, 0.04)
      border-color: #1565c0
      color: #1565c0

  .center-link
    align-self: center
    margin-top: 12px

  :deep(.v-input.v-input--error)
    .v-label, .v-field__outline, .v-messages__message
      color: #f57c00 !important
      border-color: #f57c00 !important

  :deep(.v-input.v-input--error .v-field--focused .v-field__outline)
    border-color: #f57c00 !important
    box-shadow: 0 0 0 2px rgba(245,124,0,0.15) !important
</style>
